/**
 * Cleans an object by removing nullish keys an empty objects.
 *
 * @param {Object} obj The object.
 * @returns {{[p: string]: *}}
 */
const removeEmpty = obj => {
  return Object.fromEntries(
    Object.entries(obj)
      // eslint-disable-next-line no-unused-vars
      .filter(([_, v]) => v != null)
      .map(([k, v]) => (typeof v === 'object' ? [k, removeEmpty(v)] : [k, v]))
      .filter(
        // eslint-disable-next-line no-unused-vars
        ([_, v]) => !(typeof v === 'object' && Object.keys(v).length === 0),
      ),
  );
};

export default removeEmpty;
